import React from 'react';
import { Link } from 'react-router-dom';

// Tiny className joiner (no clsx dependency).
const cx = (...c) => c.filter(Boolean).join(' ');

const VARIANTS = {
  primary:
    'bg-brand-600 text-white hover:bg-brand-700 shadow-soft hover:shadow-lift focus-visible:ring-brand-500',
  accent:
    'bg-accent-400 text-ink-900 hover:bg-accent-300 shadow-soft hover:shadow-lift focus-visible:ring-accent-400',
  secondary:
    'bg-white text-ink-800 border border-ink-200 hover:bg-ink-50 focus-visible:ring-brand-500',
  ghost:
    'bg-transparent text-ink-700 hover:bg-ink-100 focus-visible:ring-brand-500',
  outline:
    'bg-transparent text-brand-700 border border-brand-200 hover:bg-brand-50 focus-visible:ring-brand-500',
  white:
    'bg-white text-brand-700 hover:bg-ink-100 shadow-soft focus-visible:ring-white',
};

const SIZES = {
  sm: 'text-sm px-3.5 py-2 rounded-lg gap-1.5',
  md: 'text-sm px-5 py-2.5 rounded-xl gap-2',
  lg: 'text-base px-6 py-3 rounded-xl gap-2',
};

// Polymorphic button: renders <a>, react-router <Link>, or <button>.
const Button = ({
  variant = 'primary',
  size = 'md',
  to,
  href,
  className,
  children,
  ...props
}) => {
  const classes = cx(
    'inline-flex items-center justify-center font-semibold transition-all duration-200',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none',
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size] || SIZES.md,
    className
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
